import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * SupperAdminRoute - Protected route for Super Admin only
 * Checks if user is logged in AND has role = 1 (Super Admin)
 */
function SupperAdminRoute({ children }) {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');

    // Not logged in - redirect to login
    if (!token) {
        return <Navigate to="/login" replace />;
    }

    // Logged in but not Super Admin - redirect to dashboard
    if (parseInt(role) !== 1) {
        return <Navigate to="/dashboard" replace />;
    }

    // Super Admin - allow access
    return children;
}

export default SupperAdminRoute;
